export default __webpack_public_path__ + "static/media/gericht.ef04b6fc.png";